import { StripeElementLocale } from '@stripe/stripe-js';

export const fallbackLang = 'en-US';
export const languages = [fallbackLang, 'zh-HK', 'zh-CN'];
export const langCookieName = process.env.NEXT_PUBLIC_LANG_COOKIE_NAME;
export const defaultNS = '';
// stripe 本地化多语言映射 https://docs.stripe.com/js/appendix/supported_locales
export const LOCALE_LAN_MAP: Record<Lang, StripeElementLocale> = {
  'en-US': 'en',
  'zh-HK': 'zh-HK',
  'zh-CN': 'zh',
  'ja-JP': 'ja',
};

export function getOptions(lng = fallbackLang) {
  return {
    // debug: true,
    supportedLngs: languages,
    fallbackLng: fallbackLang,
    lng,
    fallbackNS: defaultNS,
  };
}
